import { CanActivateFn } from '@angular/router';
import {inject} from '@angular/core';
import {PermissionService} from '../../services/permission/permission.service';

export const roleGuard: CanActivateFn = (route, state) => {
    const role = route.data['role'];
  return inject(PermissionService).roleGuard(role);
};
